/**
* 告警邮箱页面
*
* @author By AICode
* @date 2026-04-10
*/
<template>
  <div class="alert_email_container">
    <div class="content_wrapper">
      <a-alert message="通过license平台获取激活码时间起算，当License的所有计费项中有效期最小剩余天数为30天、15天、已到期时各告警一次，告警方式：license申请人关联邮箱发邮件"
        type="info" banner />
      <FilterCondition :selected-count="selectedRowKeys.length" :search-text="searchText" :star-time="starTime"
        :end-time="endTime" @filter-change="handleFilterChange" @create="handleCreate" @delete="handleDelete"
        @import="handleImport" @export="handleExport" />
      <div class="table_wrapper">
        <a-table :columns="columns" :data-source="tableData" :row-selection="rowSelection" :loading="tableLoading"
          :rowKey="record => record.id" :pagination="paginationConfig" @change="handleTableChange"
          xScrollPlacement="tableBottom">

          <template slot="applicantName" slot-scope="applicantName">
            <a-tooltip >
              <template slot="title">
                <span>{{ applicantName }}</span>
              </template>
              <span>{{ applicantName }}</span>
            </a-tooltip>
          </template>
          <template slot="emailList" slot-scope="text, record">
            <a-tooltip :overlayStyle="{ width: '600px' }">
              <template slot="title">
                <span>{{ Array.isArray(record.emailList) ? record.emailList.join(';') : '' }}</span>
              </template>
              <div class="col_item_text">{{ Array.isArray(record.emailList) ? record.emailList.join(';') : '' }}</div>
            </a-tooltip>
            
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button type="link" class="row_action_btn" @click="handleEdit(record)">编辑</a-button>
          </template>
        </a-table>
      </div>
    </div>
    <AddEmail :visible="modalVisible" :loading="submitLoading" :mode="modalMode" :initial-values="activeRecord"
      @ok="handleSubmit" @cancel="handleCancelModal" />
  </div>
</template>

<script>
import './index.less'

import { Table, Alert, Button , Tooltip} from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import FilterCondition from './filterCondition/filterCondition.vue'
import AddEmail from './AddEmail.vue'

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('alert')

export default {
  name: 'AlertEmail',
  components: {
    FilterCondition,
    AddEmail,
    ATable: Table,
    AAlert: Alert,
    AButton: Button,
    ATooltip: Tooltip,
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 90,
        },
        {
          title: 'License申请人',
          dataIndex: 'applicantName',
          key: 'applicantName',
          ellipsis: true,
          scopedSlots: { customRender: 'applicantName' },
        },
        {
          title: '关联邮箱',
          dataIndex: 'emailList',
          key: 'emailList',
          scopedSlots: { customRender: 'emailList' },
          ellipsis: true,
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          width: 200,
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  computed: {
    ...mapState([
      'tableData',
      'tableLoading',
      'submitLoading',
      'selectedRowKeys',
      'searchText',
      'starTime',
      'endTime',
      'pagination',
      'modalVisible',
      'modalMode',
      'activeRecord',
    ]),
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (keys) => {
          this.SET_SELECTED_ROW_KEYS(keys)
        },
      }
    },
    paginationConfig() {
      return {
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
      }
    },
  },
  created() {
    this.fetchList()
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_ROW_KEYS',
      'SET_SEARCH_TEXT',
      'SET_STAR_TIME',
      'SET_END_TIME',
      'SET_PAGINATION',
      'SET_MODAL_VISIBLE',
      'SET_MODAL_MODE',
      'SET_ACTIVE_RECORD',
    ]),
    ...mapActions([
      'fetchList',
      'addAlertEmail',
      'updateAlertEmail',
      'deleteAlertEmail',
      'importAlertEmail',
      'exportAlertEmail',
    ]),
    // 筛选条件变更时重置页码并刷新列表 - By AICode
    handleFilterChange(params) {
      this.SET_SEARCH_TEXT(params?.searchText || '')
      this.SET_STAR_TIME(params?.starTime || '')
      this.SET_END_TIME(params?.endTime || '')
      this.SET_PAGINATION({ current: 1 })
      this.fetchList()
    },
    // handleCreate - By AICode
    handleCreate() {
      this.SET_MODAL_MODE('create')
      this.SET_ACTIVE_RECORD({ id: undefined, applicantName: '', emailList: [] })
      this.SET_MODAL_VISIBLE(true)
    },
    // handleEdit - By AICode
    handleEdit(record) {
      this.SET_MODAL_MODE('edit')
      this.SET_ACTIVE_RECORD({
        id: record.id,
        applicantName: record.applicantName,
        emailList: Array.isArray(record.emailList) ? record.emailList : [],
      })
      this.SET_MODAL_VISIBLE(true)
    },
    // handleSubmit - By AICode
    async handleSubmit(values) {

      if (this.modalMode === 'edit') {
        const result = await this.updateAlertEmail({
          id: this.activeRecord.id,
          applicantName: values.applicantName,
          emailList: values.emailList,
        })
        if (result === true) {
          this.$message.success('编辑成功')
          this.SET_MODAL_VISIBLE(false)
          await this.fetchList()
        }
      } else {
        const result = await this.addAlertEmail({
          applicantName: values.applicantName,
          emailList: values.emailList,
        })

        if (typeof result === 'number') {
          this.$message.success('新建成功')
          this.SET_MODAL_VISIBLE(false)
          await this.fetchList()
        }
      }


    },
    // handleCancelModal - By AICode
    handleCancelModal() {
      this.SET_MODAL_VISIBLE(false)
    },
    // handleDelete - By AICode
    async handleDelete() {
      if (!this.selectedRowKeys.length) {
        return
      }

      const result = await this.deleteAlertEmail({ ids: this.selectedRowKeys })
      if (result === true) {
        this.$message.success('删除成功')
      }

    },
    // handleImport - By AICode
    async handleImport(file) {

      const result = await this.importAlertEmail(file)
      if (!result.msg) {
        this.$message.success('导入成功')
      }


    },
    // 从 Content-Disposition 响应头中解析文件名 - By AICode
    getFileNameFromHeaders(headers) {
      const disposition = headers?.['content-disposition'] || headers?.['Content-Disposition']
      if (!disposition) {
        return `告警邮箱导出-${Date.now()}.xlsx`
      }
      const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      if (utf8Match?.[1]) {
        return decodeURIComponent(utf8Match[1])
      }
      const normalMatch = disposition.match(/filename="?([^"]+)"?/i)
      if (normalMatch?.[1]) {
        return decodeURIComponent(normalMatch[1])
      }
      return `告警邮箱导出-${Date.now()}.xlsx`
    },
    // handleExport - By AICode
    async handleExport() {

      const response = await this.exportAlertEmail({
        searchText: this.searchText,
        starTime: this.starTime,
        endTime: this.endTime,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const fileName = this.getFileNameFromHeaders(response.headers)
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
      this.$message.success('导出成功')

    },
    // handleTableChange - By AICode
    handleTableChange(pagination) {
      this.SET_PAGINATION({
        current: pagination.current,
        pageSize: pagination.pageSize,
      })
      this.fetchList()
    },
  },
}
</script>
